import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { LayoutRoutingModule } from "./layout-routing.module";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HeaderComponent } from "./header/header.component";
import { HomeComponent } from "./home/home.component";
import { SharedModule } from "../../shared/shared.module";
import { FooterComponent } from "./footer/footer.component";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    HomeComponent,
    // FooterComponent,
  ],
  exports: [SidebarComponent, HeaderComponent, HomeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LayoutRoutingModule,
    SharedModule,
    FooterComponent,
  ],
})
export class LayoutModule {}
